import { initialStateBase, reducer } from './newCollection';

export const baseUrl = '/api/re-projects/v1/real-estate/business';

export const urls = {
    getProject: id => `${baseUrl}/projects/${id}`,
    getAllProjects: `${baseUrl}/projects/listing`,
    getLeadFormData: `${baseUrl}/leads/form`,
    submitLeadForm: `${baseUrl}/leads`,
    getCarouselData: `${baseUrl}/projects/count`
};

export const initialState = {
    ...initialStateBase,
    metadataKey: 'reProjects',
    aditionalMetadataKeys: ['title', 'nextPage', 'nextPageUrl', 'locationName', 'appliedFilters', 'locationFilter']
};
const transformData = (state, { data }) => {
    let projects = data.projects || [];
    const currPage = data.currentPage && data.currentPage + 1 || 1;

    projects = projects.map((obj, i) => {
        obj.pageNo = currPage;
        obj.sequence = ((currPage - 1) * projects.length) + i + 1;
        return obj;
    });

    return {
        data: projects,
        metadata: {
            total: data.projectCount,
            appliedFilters: data.appliedFilters,
            locationName: data.locationName,
            nextPageUrl: data.nextPageUrl,
            nextPage: data.nextPage,
            currentPage: currPage,
            title: data.title,
            locationFilter: {
                filters: data.filters
            }
        }
    };
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'ERROR_ELEMENT_PROJECTS':
        case 'REQUEST_ELEMENT_PROJECTS':
            return reducer(state, action, 'PROJECTS');
        case 'RECEIVE_ELEMENT_PROJECTS':
            return reducer(state, action, 'PROJECTS');

        case 'ERROR_PROJECT_LEAD_FORM':
        case 'REQUEST_PROJECT_LEAD_FORM':
            return reducer(state, action, 'PROJECT_LEAD_FORM');
        case 'RECEIVE_PROJECT_LEAD_FORM': {
            const newState = Object.assign({}, state, { leadFormData: action.data && action.data.data });

            return reducer(newState, action, 'PROJECT_LEAD_FORM');
        }
        case 'ERROR_GET_ALL_PROJECTS':
        case 'REQUEST_GET_ALL_PROJECTS': {
            action.url = action.url.replace(/&*(page)=[^&]*/ig, '');
            return reducer(state, action, 'GET_ALL_PROJECTS');
        }
        case 'RECEIVE_GET_ALL_PROJECTS': {
            action.url = action.url.replace(/&*(page)=[^&]*/ig, '');
            action.data = transformData(state, action.data);
            return reducer(state, action, 'GET_ALL_PROJECTS');
        }

        case 'ERROR_PROJECT_CAROUSEL_DATA':
        case 'RECEIVE_PROJECT_CAROUSEL_DATA' : {
            return {
                ...state,
                carouselData: {
                    ...state.carouselData,
                    data: action.data && action.data.data
                }
            };
        }

        case 'SET_CAROUSEL_LOCATION': {
            return {
                ...state,
                carouselData: {
                    ...state.carouselData,
                    locationId: action.locationId.locationId
                }
            };
        }

        default:
            return state || null;
    }
};

